import { render, staticRenderFns } from "./NoResize.vue?vue&type=template&id=2a949bd4&"
import script from "./NoResize.vue?vue&type=script&lang=js&"
export * from "./NoResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports